import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getBalancedMenu } from '../../actions/menus';
import DishesList from '../../components/DishesPage/DishesList';
import DishDetails from '../../components/DishesPage/DishDetails';
import PageWithHeader from '../../components/PageWithHeader/PageWithHeader';

// import styles from './Menu.module.css';

const Menu = (props) => {
  const {
    menus,
    getBalancedMenu,
  } = props;
  
  const [showDish, setShowDish] = useState(false);

  useEffect(() => {
    getBalancedMenu();
  }, []);

  if (_.isEmpty(menus)) {
    return null;
  }

  if (showDish) {
    return (
      <DishDetails 
        dishId={showDish.id}
        day={showDish.day}
        onBack={() => setShowDish(false)}
        isBalanced
      />
    );
  }

  return (
    <PageWithHeader>
      <DishesList 
        menus={menus} 
        onShowDish={setShowDish}
        isBalanced
      />
    </PageWithHeader>
  );
};

const mapStateToProps = (state) => ({
  menus: state.menus.menusData,
});

const mapDispatchToProps = {
  getBalancedMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);